var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigGrowthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 404.362,
    height: 64.61,
    viewBox: "0 0 404.362 64.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.019,
    y1: 0.868,
    x2: 0.898,
    y2: 0.417,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9149ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e600ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.085,
    y1: 0.87,
    x2: 0.951,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191867",
    "data-name": "Group 191867",
    transform: "translate(-7.639 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191733",
    "data-name": "Group 191733",
    transform: "translate(7.639 23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_46",
    "data-name": "Union 46",
    d: "M58.017,26.122C58.017,13.216,67.882,4.1,80.043,4.1c9,0,16.752,4.529,20.041,12.968h-8.5c-2.3-4.343-6.391-6.515-11.541-6.515-8.562,0-14.767,6.08-14.767,15.574s6.205,15.635,14.767,15.635c7.818,0,12.719-4.715,13.774-11.975H77.623V24.136h23.764v5.522a21.261,21.261,0,0,1-21.344,18.49C67.882,48.148,58.017,39.09,58.017,26.122ZM43.994,47.776V13.588h7.073V47.776ZM0,47.776V4.654H14.085c13.837,0,22.9,8.376,22.9,21.716,0,13.278-9.059,21.406-22.9,21.406Zm7.073-5.771h7.012c10.175,0,15.636-5.832,15.636-15.636,0-9.865-5.461-15.946-15.636-15.946H7.073ZM43.063,4.529a4.5,4.5,0,1,1,9,0,4.5,4.5,0,1,1-9,0Z",
    transform: "translate(79.101 5.35)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316297",
    "data-name": "Path 316297",
    d: "M411.933,31.843h-8.5c-2.3-4.344-6.391-6.515-11.541-6.515-8.562,0-14.767,6.08-14.767,15.574s6.205,15.636,14.767,15.636c7.818,0,12.719-4.715,13.775-11.975H389.472V38.916h23.764v5.522a21.261,21.261,0,0,1-21.344,18.49c-12.161,0-22.026-9.058-22.026-22.026,0-12.905,9.865-22.027,22.026-22.027,9,0,16.753,4.53,20.041,12.968",
    transform: "translate(-184.784 -9.43)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316298",
    "data-name": "Path 316298",
    d: "M477.5,71.476h-7.074V37.288H477.5v4.964c1.985-3.412,5.4-5.522,10.237-5.522v7.322h-1.8c-5.212,0-8.438,2.171-8.438,9.431Z",
    transform: "translate(-235.024 -18.35)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316299",
    "data-name": "Path 316299",
    d: "M530.58,72.035c-9.741,0-17.125-6.949-17.125-17.683S521.149,36.73,530.89,36.73s17.435,6.887,17.435,17.622-7.942,17.683-17.745,17.683m0-6.142c5.274,0,10.486-3.785,10.486-11.54s-5.026-11.479-10.3-11.479c-5.336,0-10.114,3.722-10.114,11.479s4.592,11.54,9.927,11.54",
    transform: "translate(-256.52 -18.35)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316300",
    "data-name": "Path 316300",
    d: "M589.094,37.845h7.2l7.135,27.487,7.259-27.487h7.384l6.95,27.363,7.073-27.363h6.949l-10.61,34.188h-7.445L614.1,46.78l-6.887,25.253h-7.446Z",
    transform: "translate(-294.309 -18.907)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316301",
    "data-name": "Path 316301",
    d: "M697.658,35.13h-4.033V29.359h4.033v-8.5h7.135v8.5h8.314V35.13h-8.314V54.053c0,2.544.993,3.6,3.971,3.6h4.343v5.894h-5.584c-6.081,0-9.865-2.544-9.865-9.493Z",
    transform: "translate(-346.532 -10.421)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316302",
    "data-name": "Path 316302",
    d: "M745.58,14.411h7.073v15.7a13.552,13.552,0,0,1,10.61-4.53c7.632,0,13.588,5.026,13.588,14.581V60.326h-7.012V41.215c0-6.266-3.412-9.493-8.562-9.493-5.212,0-8.624,3.227-8.624,9.493V60.326H745.58Z",
    transform: "translate(-372.489 -7.2)",
    fill: "#163567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316303",
    "data-name": "Path 316303",
    d: "M59.69,37.458,50.075,50.943,40.6,44.988a3.581,3.581,0,0,0-5.016.705L23.377,61.052l-.005.006a3.606,3.606,0,0,0,.582,5.066,3.535,3.535,0,0,0,2.235.793,3.679,3.679,0,0,0,2.861-1.491l9.615-12.211s9.587,6.1,9.764,6.221a3.58,3.58,0,0,0,4.988-.873L65.555,41.736v-.072a3.609,3.609,0,1,0-5.865-4.206",
    transform: "translate(-11.286 -17.961)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316304",
    "data-name": "Path 316304",
    d: "M41.115,3.254A20.264,20.264,0,0,1,61.356,23.494V41.116A20.264,20.264,0,0,1,41.115,61.357H23.494A20.264,20.264,0,0,1,3.254,41.116V23.494A20.264,20.264,0,0,1,23.494,3.254Zm0-3.254H23.494A23.494,23.494,0,0,0,0,23.494V41.116A23.494,23.494,0,0,0,23.494,64.61H41.115A23.5,23.5,0,0,0,64.61,41.116V23.494A23.5,23.5,0,0,0,41.115,0",
    transform: "translate(0 0)",
    fill: "#163567"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigGrowthLogo);
export default __webpack_public_path__ + "static/media/DigGrowthLogo.3cbafa3a0742b416898a94669d161052.svg";
export { ForwardRef as ReactComponent };